import { Lookup } from './lookup.model';
import { OptionSet } from './optionSet.model';
export class Procesox {
    IdProceso: any;
    PresentaDiscapacidad: boolean;
    DeseaAsesoria: boolean;
    EsApoderado: boolean;
    EstoyCursandoCuartoMedio: boolean;
    DeseaUsarCredito: boolean;
    CheckProntoPago: boolean;
    
    FasePortal: OptionSet;
    FechaDatosPersonales: string;
    NombreApoderado: string;
    RutApoderado: string;
    SerialAceptante: string;
    FechaNacimientoApoderado: string;
    RegionApoderado: Lookup;
    ComunaApoderado: Lookup;
    DireccionApoderado: string;
    TelefonoCelularApoderado: string;
    CorreoElectronicoApoderado: string;
    Institucion: Lookup;
    Sede: Lookup;
    OfertaAdmision: Lookup;
    TipoIngreso: Lookup;
    CopagoMatricula: number;
    CopagoMatricula1: number;
    CopagoMatricula2: number;
    ProcentajeDesMatricula: number;
    ValorDescMatricula: number;
    CopagoMatriculaTotal: number;
    CopagoArenceles: number;
    CopagoAranceles1: number;
    CopagoAranceles2: number;
    MontoBecaAsignable: number;
    MontoBeca: number;
    ValorColegAPagar: number;
    ValorColegAPagar1: number;
    Porcentaje: number;
    ValorDescuento: number;
    PorcentajeDescuentoBecode: number;
    ValorDescuentoBecode: number;
    ValorColegAPagar2: number;
    MontoCae: number;
    MontoAUtilizar: number;
    ColegaDoc: number;
    MontoAlDia: number;
    FechaDocumento: string;
    AbonoMatricula: number;
    AbonoColegiatura: number;
    MatriculaADoc: number;
    ColegaDoc1: number;
    Total1Sem: number;
    Total2Sem: number;
    TipoDePago1: string;
    TipoDePago2: string;
    Cuotas1: number;
    Cuotas2: number;
    FechaPago1: string;
    FechaPago2: string;
    Contacto: Lookup;
    Carrera: Lookup;
    DireccionSede: string;
    
    constructor(data: any) {
        //Texto
        this.IdProceso = data.id;
        this.FechaDatosPersonales = '';
        this.NombreApoderado = data.ANombre;
        this.RutApoderado = data.ARut;
        this.SerialAceptante = data.Aserialrut;
        this.FechaNacimientoApoderado = data.AFechaN;
        this.DireccionApoderado = data.ADireccion;
        this.TelefonoCelularApoderado = data.ATelefono;
        this.CorreoElectronicoApoderado = data.ACorreo;
        this.FechaDocumento = '';
        this.TipoDePago1 = '';
        this.TipoDePago2 = '';
        this.FechaPago1 = '';
        this.FechaPago2 = '';
        this.DireccionSede = '';

        //Boolean
        this.PresentaDiscapacidad = data.PresentaDiscapacidad;
        this.DeseaAsesoria = data.DeseaRecibirAsesoria;
        this.EsApoderado = data.EsApoderado;
        this.EstoyCursandoCuartoMedio = data.CuarsandoCuartoMedio;
        this.DeseaUsarCredito = false;
        this.CheckProntoPago = false;
        //Fase
        this.FasePortal = new OptionSet(data.FasePortal);
        //lookup
        this.RegionApoderado = new Lookup(data.ARegion, "", "xmsbs_region");
        this.ComunaApoderado = new Lookup(data.AComuna, "", "xmsbs_comuna");
        this.Contacto = new Lookup(data.IdContacto, '', 'contact');
    }
    
    set ProcesoId(idproceso: any) {
        console.log('set data '+ idproceso); 
        this.IdProceso = idproceso 
    }

}